import React from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { Menu, Icon } from "antd";
import SignupModal from "./account/SignupModal";
import HeaderIcon from "./HeaderIcon";
import SearchTextures from "./SearchTextures";

const TextureHeader = ({ auth }) => (
  <Menu
    mode="horizontal"
    theme="dark"
    style={{
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      boxShadow: "1px 0px 6px #0000006e",
    }}
    selectable={false}
  >
    <Menu.Item style={{ padding: 0, marginLeft: "1em" }}>
      <Link to="/" onClick={() => window.location.reload()}>
        <HeaderIcon />
      </Link>
    </Menu.Item>
    {/* <Menu.Item style={{ paddingLeft: 3 }}>
    <Link to="/" onClick={e => window.location.reload()}>
      <h1 style={{ marginBottom: 0, color: "white" }}>TEXTURE NINJA</h1>
    </Link>
  </Menu.Item> */}
    <Menu.Item style={{ cursor: "default" }}>
      <SearchTextures />
    </Menu.Item>
    {auth ? (
      <Menu.SubMenu
        style={{ marginLeft: "auto" }}
        key="sub1"
        title={
          <span>
            <Icon className="hvr-grow" type="menu-unfold" style={{ fontSize: "1.5em" }} />
            <span />
          </span>
        }
      >
        {auth.role === "ADMIN" && (
          <Menu.Item>
            <Link to="/admin">Admin</Link>
          </Menu.Item>
        )}
        <Menu.Item>
          <Link to="/account">Account</Link>
        </Menu.Item>
        {(auth.role === "CONTRIBUTOR" || auth.role === "ADMIN") && (
          <Menu.Item>
            <Link to="/contribute">Contribute</Link>
          </Menu.Item>
        )}

        <Menu.Item>
          <a href="/api/logout">Logout</a>
        </Menu.Item>
      </Menu.SubMenu>
    ) : (
      <Menu.Item style={{ marginLeft: "auto" }}>
        <SignupModal />
      </Menu.Item>
    )}
  </Menu>
);

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(TextureHeader);



// WEBPACK FOOTER //
// ./src/components/Header.js